
import axios from "axios";

import { IP } from "utils/Host";

// zmiana procesora w grupie z poziomu technologia stage
export function dropStagePrzesunZadanie(draggedId,targetId,oldProcesorId,newProcesorId,refreshGantAll) {

// id = procesor id
console.log("dropStagePrzesunZadanie")
  
  axios
  .get(IP + "API_0003_gant_procedura_przesun_zadanie/"+draggedId+"/"+targetId+"/"+oldProcesorId+"/"+newProcesorId+"/" + sessionStorage.getItem("token"))
    .then((res) => {
refreshGantAll()

    })
}

//   +"/" + sessionStorage.getItem("token")

